import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Page not found | Anxiety Fix Wellness Network";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => { document.title = prevTitle; meta.remove(); };
  }, []);

  return (
    <div data-testid="not-found-page" className="min-h-screen bg-afwn-bg text-afwn-navy flex flex-col items-center justify-center px-6 text-center">
      <p className="text-sm tracking-wider uppercase font-semibold text-afwn-green">404</p>
      <h1 className="mt-4 font-heading font-light text-4xl sm:text-5xl">This page has moved on.</h1>
      <p className="mt-4 text-afwn-slate text-lg max-w-md">The link you followed doesn’t exist anymore — but your calm journey is right here.</p>
      <Link to="/" data-testid="not-found-home" className="mt-8 inline-flex items-center gap-2 rounded-full font-medium px-8 py-4 bg-afwn-green text-white hover:bg-afwn-greenDark transition-all duration-300 hover:scale-[1.03]">Back to home <ArrowRight size={18} /></Link>
    </div>
  );
}
